import { GatsbyImage, getImage, IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';

import * as styles from './provider-profile-slider.module.css';

interface ProviderProfileSliderProps {
	slides: {
		image: {
			asset: { gatsbyImageData: IGatsbyImageData; url: string };
			alt: string;
		};
		providerName: string;
		credentials: string;
		state: string;
	}[];
}

export function ProviderProfileSlider({
	slides = [],
}: ProviderProfileSliderProps) {
	// repeat slides 2x for seamless loop
	const repeatedSlides = [...slides, ...slides];

	// animation duration: 3s per slide, total = slides.length * 3 * 2 (for 2x)
	const duration = slides.length * 3 * 2;

	return (
		<div className={styles.sliderWrapper}>
			<div
				className={styles.sliderTrack}
				style={{
					animationDuration: `${duration}s`,
				}}
			>
				{repeatedSlides.map((slide, idx) => {
					const imageData = getImage(slide.image.asset);

					return (
						<div
							className={styles.slide}
							key={slide.providerName + idx + idx}
						>
							<div className={styles.imageContainer}>
								{imageData && (
									<GatsbyImage
										image={imageData}
										alt={
											slide.image?.alt ??
											'Profile image of provider'
										}
										className={styles.image}
									/>
								)}
							</div>
							<div className={styles.info}>
								<div className='body-display-sm'>
									{slide.providerName}
								</div>
								<div className='body-s-bold'>
									{slide.credentials}
									{slide.state ? `, ${slide.state}` : ''}
								</div>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
}
